module.exports = __webpack_public_path__ + "static/media/business_icon.da7cb0e4.svg";